import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import InlineSvg from 'app/common/InlineSvg'

import * as styles from './InsightsLogo.less'

const logoUrl = require(`static/images/${
  process.env.MANZAMA_BRAND === 'diligent' ? 'diligent' : 'insights'
}-logotype.svg`)

export const COLORS = {
  LIGHT: 'light',
  DARK: 'dark',
}

export default function InsightsLogo({
  color = COLORS.DARK,
  className,
  ...restProps
}) {
  return (
    <InlineSvg
      src={logoUrl}
      className={classNames(styles.logo, className, {
        [styles.light]: color === COLORS.LIGHT,
        [styles.dark]: color === COLORS.DARK,
      })}
      {...restProps}
    />
  )
}
InsightsLogo.propTypes = {
  color: PropTypes.oneOf(Object.values(COLORS)),
  className: PropTypes.string,
}
InsightsLogo.COLORS = COLORS
